// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aNC6TW0gogWkXw9mBIpY{cursor:pointer;border-radius:6px;justify-content:space-between;align-items:center;height:33px;padding:0 8px;display:flex}.aNC6TW0gogWkXw9mBIpY:hover{background:var(--background-neutral-subtle)}.aNC6TW0gogWkXw9mBIpY:last-of-type{margin-bottom:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `aNC6TW0gogWkXw9mBIpY`
};
export default ___CSS_LOADER_EXPORT___;
